import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
      <a href="https://www.instagram.com/zydzdnee/" className="home__social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-instagram"></i>
      </a>
      <a href="https://www.linkedin.com/in/ziyad-f-zidane/" className="home__social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-linkedin-alt"></i>
      </a>
      <a href="https://github.com/ziyadoodle" className="home__social-icon" target="_blank" rel="noreferrer">
        <i className="uil uil-github-alt"></i>
      </a>
    </div>
  )
}

export default Social